import React from 'react';

import ChallengePanelCard from '~/components/PanelCards/ChallengePanelCard';
import LoadingComponent from '../LoadingComponent';

import * as Style from './styles';

function ChallengePagePanel({
    panelLoaded,
    challengeData,
    totalSalesValue,
    quotaLabel,
    currentQuotaValue,
    salesPercentage,
}) {
    if (!panelLoaded) {
        return <LoadingComponent />;
    }

    return (
        <Style.Wrap>
            <ChallengePanelCard
                challengeData={challengeData}
                totalSalesValue={totalSalesValue}
                quotaLabel={quotaLabel}
                currentQuotaValue={currentQuotaValue}
                salesPercentage={salesPercentage}
            />

            <Style.StyledStepper
                variant="dots"
                steps={1}
                activeStep={0}
                position="static"
            />
        </Style.Wrap>
    );
}

export default ChallengePagePanel;
